module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.a0c47b73.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }